import { EmptyData, NavMenuError } from 'shared/ui';
import { SectionMenu } from 'shared/ui/section-menu';
import { BANK_ROUTES } from 'shared/consts/routes/bank';

import { SECTION } from 'entities/navigation';
import { useGetBanksQuery } from 'entities/bank';

import { AddButton } from './add-button';

const { label, path } = SECTION['banks'];

export function ConnectedBanksMenu() {
  const { data, isFetching, error } = useGetBanksQuery();

  if (data && data.statusCode !== 0) {
    return <NavMenuError text={data.statusDescription} />;
  }

  if (error) {
    return <NavMenuError />;
  }

  if (!isFetching && !data) {
    return <EmptyData />;
  }

  const items = data?.banks || [];

  return (
    <SectionMenu
      loading={isFetching}
      items={items}
      menuKey={path}
      absolutePath={BANK_ROUTES.BANKS}
      label={label}
      addButton={<AddButton />}
    />
  );
}
